export class Project {
  constructor(private readonly id: number, private readonly uuid: string, private readonly name: string) {}

  getId() {
    return this.id;
  }

  getUuid() {
    return this.uuid;
  }

  getName() {
    return this.name;
  }
}
